<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/beipanjiangIndex">首页</el-menu-item>
        <el-submenu :index="'/beipanjiang/station'">
          <template slot="title">主缆除湿机组</template>
          <el-menu-item index="/beipanjiang/station/east"> 东侧主缆除湿机组 </el-menu-item>
          <el-menu-item index="/beipanjiang/station/west"> 西侧主缆除湿机组 </el-menu-item>
        </el-submenu>
        <el-menu-item index="/beipanjiang/currentHumidityList?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331&includePower=true"
          >湿度数据清单</el-menu-item
        >
        <el-submenu :index="'/beipanjiang/highFrequencyCurrentData?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331'">
          <template slot="title">高频实验</template>
          <el-menu-item index="/beipanjiang/highFrequencyCurrentData?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331"> 高频实验实时数据 </el-menu-item>
          <el-menu-item index="/beipanjiang/highFrequencyStatusControl?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331">
            高频实验设备管理
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/beipanjiang/errorRecord?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331">报警记录</el-menu-item>
        <el-menu-item index="/beipanjiang/currentDataTable?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331">实时数据表</el-menu-item>
        <el-submenu :index="'/beipanjiang/dataHistory?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/beipanjiang/dataHistory?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/beipanjiang/dataHistory?bridgeId=7c94a3ff-3eaa-4965-8314-56422f799331"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="beipanjiang" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"> </HeaderTime>
    </el-header>
    <el-main class="el-main beipanjiang">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "beipanjiang",
  data() {
    return {
      bridgeId: "7c94a3ff-3eaa-4965-8314-56422f799331",
      envInfo: {
        envId: "2860c03a-1dc5-4ba5-bd74-7b209ef6c4c6",
        weather: "fdc9209b-4a7b-460e-be3e-8937b4b0780d",
        humidity: "55cfc473-f429-40c9-8cb8-6c9f345db4cb",
        temperature: "1c5c3708-605f-4939-9e83-3e92537b8a21",
        weatherAbsoluteHumidity: "7cfbd81f-6a76-44c4-95e9-866b703a2344",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>
